import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import FeatureGrid from './components/FeatureGrid';
import Benefits from './components/Benefits';
import HowItWorks from './components/HowItWorks';
import ArticleEntry from './components/ArticleEntry';
import Testimonials from './components/Testimonials';
import Security from './components/Security';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <CategoryGrid />
      <CTASection />
      <FeatureGrid />
      <Benefits />
      <HowItWorks />
      <ArticleEntry />
      <Testimonials />
      <Security />
      <Footer />
    </main>
  );
}